/* ============================================================
   Immersive Bear Scroll — UN video teddy come sfondo di tutto il finale
   ------------------------------------------------------------
   • Layer video (.scm-teddylayer) spostato su <body>, fisso dietro il finale
     (sezioni trasparenti: immersive → story → split → cerimonia → experience →
     trust → newsletter). Progresso scrub mappato dall'immersive alla newsletter.
   • Scrub: video.currentTime = easedProgress * duration (rAF).
   • Fallback autoplay+fade se duration assente / non supportato.
   • Step testuali della sezione immersive controllati a parte.
   • Nessuna libreria. prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function probeFx() {
    if (reduce) return;
    var p = document.createElement("div");
    p.style.cssText = "position:fixed;left:-9999px;top:0;width:2px;height:2px;opacity:0;transition:opacity .2s linear;pointer-events:none;";
    document.body.appendChild(p);
    void p.offsetWidth; p.style.opacity = "1";
    setTimeout(function () {
      if (parseFloat(getComputedStyle(p).opacity) > 0.05) document.documentElement.classList.add("scm-fx");
      p.remove();
    }, 90);
  }

  /* ---------- Layer teddy unico (video globale) ---------- */
  function initLayer(layer) {
    if (layer.__scmInit) return; layer.__scmInit = true;
    try { document.body.appendChild(layer); } catch (e) {}

    var video = layer.querySelector(".scm-immersive__video");
    var canvas = layer.querySelector(".scm-immersive__canvas");
    var zoomEl = video || canvas;
    var startId = layer.getAttribute("data-start");
    var wantScrub = layer.getAttribute("data-scrub") === "true" && !reduce && !!video;
    var autoFallback = layer.getAttribute("data-autoplay-fallback") !== "false";
    var zoom = layer.getAttribute("data-zoom") !== "false";

    var dur = 0, ready = false, scrubActive = false, playMode = false, cur = 0, target = 0, vraf = null;
    function markReady() { if (video) video.classList.add("scm-ready"); }
    function ease() {
      vraf = null;
      cur += (target - cur) * 0.16;
      if (Math.abs(target - cur) < 0.0008) cur = target;
      if (ready && dur && isFinite(dur)) { try { video.currentTime = clamp(cur, 0, 1) * dur; } catch (e) {} }
      if (Math.abs(target - cur) > 0.0004) vraf = window.requestAnimationFrame(ease);
    }
    function scrubTo(p) { target = p; if (!vraf) vraf = window.requestAnimationFrame(ease); }
    function prime() {
      var p = video.play && video.play();
      if (p && p.then) p.then(function () { try { video.pause(); } catch (e) {} }).catch(function () {});
      else { try { video.pause(); } catch (e) {} }
    }
    function startFallback() {
      if (scrubActive) return;
      // Lo scrub non e' disponibile (es. server locale senza range-request, mobile,
      // browser): si passa ad autoplay-in-view gestito da onScroll (play quando la
      // scena e' visibile, pausa quando esci). Niente loop a vuoto su tutta la pagina.
      if (video && autoFallback) { playMode = true; try { video.loop = true; } catch (e) {} }
      markReady();
    }

    if (video) {
      if (wantScrub) {
        video.loop = false; video.muted = true; video.playsInline = true;
        function activateScrub() {
          if (scrubActive) return;
          ready = true; dur = video.duration || dur;
          if (dur && isFinite(dur) && dur > 0) {
            scrubActive = true;
            try { video.loop = false; video.pause(); } catch (e) {}
            markReady(); prime();
            try { video.currentTime = clamp(target, 0, 1) * dur; } catch (e) {}
          }
        }
        video.addEventListener("loadedmetadata", function () { dur = video.duration || 0; });
        video.addEventListener("loadeddata", activateScrub);
        video.addEventListener("canplay", activateScrub);
        video.addEventListener("error", startFallback);
        // Carica l'intero video come blob: garantisce il "seek" fluido legato
        // allo scroll anche se il server non supporta le range-request (es. dev
        // server locale) o il file non e' completamente bufferizzato.
        var srcEl = video.querySelector("source");
        var vurl = (srcEl && srcEl.getAttribute("src")) || video.getAttribute("src") || "";
        if (vurl && window.fetch) {
          fetch(vurl).then(function (r) { if (!r.ok) throw 0; return r.blob(); })
            .then(function (b) { try { video.src = URL.createObjectURL(b); video.load(); } catch (e) { try { video.load(); } catch (e2) {} } })
            .catch(function () { try { video.load(); } catch (e) {} });
        } else { try { video.load(); } catch (e) {} }
        setTimeout(function () { if (!scrubActive) startFallback(); }, 9000);
      } else {
        // Autoplay-in-view: play quando la scena e' visibile, pausa quando esci
        // (gestito in onScroll). Robusto ovunque, mai bloccato.
        playMode = true;
        try { video.loop = true; video.muted = true; video.playsInline = true; } catch (e) {}
        video.addEventListener("playing", markReady);
        video.addEventListener("loadeddata", markReady);
        video.addEventListener("canplay", markReady);
        if (video.readyState >= 2) markReady();
        setTimeout(function () { if (video.readyState >= 2) markReady(); }, 1200);
      }
    }

    function onScroll() {
      var startEl = document.getElementById(startId);
      if (!startEl) return;
      // Il teddy e' lo sfondo fisso di TUTTO il finale: le sezioni story, split,
      // cerimonia, experience, trust e newsletter sono trasparenti e stanno sopra
      // il video. Lo scrub va quindi mappato dall'inizio dell'immersive fino in
      // fondo all'ultima sezione del finale (newsletter), poco prima del footer.
      var endEl = document.querySelector(".scm-news") || startEl;
      var y = window.scrollY || window.pageYOffset || 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var sTop = startEl.getBoundingClientRect().top + y;
      var eBottom = endEl.getBoundingClientRect().bottom + y;
      var total = eBottom - sTop - vh;
      var p = total > 0 ? clamp((y - sTop) / total, 0, 1) : 0;
      var on = (y + vh > sTop + 8) && (y < eBottom - 8);
      layer.classList.toggle("scm-on", on);
      if (on) {
        if (scrubActive) scrubTo(p);
        else if (playMode && video && video.paused) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
        if (zoomEl && zoom && !reduce) zoomEl.style.transform = "scale(" + (1.04 + p * 0.12).toFixed(3) + ")";
      } else if (playMode && video && !video.paused) {
        try { video.pause(); } catch (e) {}
      }
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /* ---------- Step testuali della sezione immersive ---------- */
  function initSteps(section) {
    if (section.__scmSteps) return; section.__scmSteps = true;
    var steps = [].slice.call(section.querySelectorAll(".scm-immersive__step"));
    var dots = [].slice.call(section.querySelectorAll(".scm-immersive__progress span"));
    var active = -1;
    function setStep(i) {
      if (i === active) return; active = i;
      steps.forEach(function (s, si) { s.classList.toggle("scm-active", si === i); });
      dots.forEach(function (d, di) { d.classList.toggle("scm-on", di === Math.min(i, 2)); });
    }
    function onScroll() {
      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - (window.innerHeight || 0);
      var progress = scrollable > 0 ? clamp(-rect.top / scrollable, 0, 1) : 0;
      setStep(progress < 0.25 ? 0 : (progress < 0.5 ? 1 : (progress < 0.75 ? 2 : 3)));
      section.classList.toggle("scm-immersive--closing", progress >= 0.75);
    }
    setStep(0); onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  function boot() {
    probeFx();
    document.querySelectorAll("[data-teddylayer]").forEach(initLayer);
    document.querySelectorAll(".scm-immersive").forEach(initSteps);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
